/// AXIOS ///
import axios from "axios";
import { AxiosError } from "axios";
/// REDUX ///
import { Dispatch } from "redux";
import { RootState } from "api/reducers";
/// ACTIONS ///
import { Action } from "api/action_types/shop_material";
import { Action as AuthAction } from "api/action_types/authentication";
/// ACTION TYPES ///
import { ActionType } from "api/action_types/shop_material";
import { ActionType as AuthActionType } from "api/action_types/authentication";
/// TYPES ///
import { IShopMaterial } from "api/types/shop_material";
/// URLS ///
import { shop_material_url } from "../../endpoint";
import { url_prefix } from "settings";

export const updateShopMaterial = (material: IShopMaterial, id: string | number) => {
  return async (dispatch: Dispatch<Action | AuthAction>, getState: () => RootState) => {

    const { user } = getState().authentication;

    dispatch({
      type: ActionType.SHOP_MATERIAL_LOADING
    });

    dispatch({
      type: ActionType.UPDATE_LOCAL_SHOP_MATERIAL,
      material
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Token ${user.token}`
      }
    }

    const url = `${url_prefix}${shop_material_url}/${id}/`;

    try {
      await axios.patch(url, material, config);

      dispatch({
        type: ActionType.UPDATE_SHOP_MATERIAL
      });
    }
    catch (err) {
      if (err instanceof AxiosError) {
        dispatch({
          type: ActionType.SHOP_MATERIAL_ERROR,
          error: err.message
        });
        if (err && err.response && err.response.status === 401) {
          dispatch({
            type: AuthActionType.AUTH_FAILED
          });
        }
      }
    }
  }
}
